import t, { Component as e } from "react";
import r from "../../../../node_modules/classnames/index.js";
function n(t) {
  if (void 0 === t) throw ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t;
}
function o(t, e) {
  for (var r = 0; r < e.length; r++) {
    var n = e[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
  }
}
function a(t, e, r) {
  return e in t ? Object.defineProperty(t, e, {
    value: r,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : t[e] = r, t;
}
function i(t) {
  return (i = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  })(t);
}
function u(t, e) {
  return (u = Object.setPrototypeOf || function (t, e) {
    return t.__proto__ = e, t;
  })(t, e);
}
var s = function (e) {
  !function (t, e) {
    if ("function" != typeof e && null !== e) throw TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
      constructor: {
        value: t,
        writable: !0,
        configurable: !0
      }
    }), e && u(t, e);
  }(f, e);
  var s,
    c,
    l,
    p = (s = function () {
      if ("undefined" == typeof Reflect || !Reflect.construct || Reflect.construct.sham) return !1;
      if ("function" == typeof Proxy) return !0;
      try {
        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
      } catch (t) {
        return !1;
      }
    }(), function () {
      var t,
        e,
        r = i(f);
      if (s) {
        var o = i(this).constructor;
        e = Reflect.construct(r, arguments, o);
      } else e = r.apply(this, arguments);
      return (t = e) && ("object" == (t && "undefined" != typeof Symbol && t.constructor === Symbol ? "symbol" : typeof t) || "function" == typeof t) ? t : n(this);
    });
  function f() {
    var e;
    return !function (t, e) {
      if (!(t instanceof e)) throw TypeError("Cannot call a class as a function");
    }(this, f), e = p.apply(this, arguments), a(n(e), "handle", null), a(n(e), "outerWrapper", t.createRef()), a(n(e), "container", t.createRef()), a(n(e), "state", {
      dragging: !1,
      zoom: !1
    }), a(n(e), "getContainer", function () {
      return n(e);
    }), a(n(e), "shiftForDrag", function (t) {
      e.outerWrapper.current.style["margin" + (t ? "Bottom" : "Top")] = e.props.shiftMargin || "100px";
    }), a(n(e), "unshiftForDrag", function () {
      e.outerWrapper.current && (e.outerWrapper.current.style.marginTop = "0", e.outerWrapper.current.style.marginBottom = "0");
    }), a(n(e), "handleDragStart", function (t) {
      e.handle && e.handle.contains(e.state.target) || !e.handle && e.state.target === e.container.current ? (t.dataTransfer.setData("text/plain", ""), e.setState({
        zoom: !1,
        dragging: !0
      })) : t.preventDefault(), "function" == typeof e.props.onDragStart && e.props.onDragStart(n(e));
    }), a(n(e), "handleDragEnd", function () {
      e.setState({
        zoom: !1,
        dragging: !1,
        target: void 0
      }), "function" == typeof e.props.onDragEnd && e.props.onDragEnd();
    }), a(n(e), "handleDrop", function () {
      if (!e.props.draggable) return;
    }), a(n(e), "handleDragEnter", function () {
      "function" == typeof e.props.onDragOver && e.props.onDragOver(n(e));
    }), a(n(e), "handleMouseup", function () {
      e.state.zoom && e.setState({
        zoom: !1,
        dragging: !1
      });
    }), a(n(e), "handleMousedown", function (t) {
      e.handle && e.handle.contains(t.target) ? e.setState({
        dragging: !0,
        zoom: !0,
        target: e.handle
      }) : e.handle || t.target !== e.container.current || e.setState({
        dragging: !0,
        zoom: !0,
        target: e.container.current
      });
    }), a(n(e), "handleDragOver", function (t) {
      t.preventDefault();
    }), a(n(e), "setHandle", function (t) {
      e.handle = t;
    }), e;
  }
  return c = [{
    key: "render",
    value: function value() {
      var e = this,
        n = r("draggable__container", {
          draggable: !this.handle,
          dragging: this.state.dragging,
          zoom: this.state.zoom,
          "float-to-front": this.props.floatToFront
        });
      return t.createElement("div", {
        ref: this.outerWrapper,
        className: r("kaseya-ui-draggable-container draggable__outer", this.props.className),
        onMouseUp: this.handleMouseup,
        onMouseDown: this.handleMousedown
      }, t.createElement("div", {
        ref: this.container,
        draggable: !!(!this.props.disabled && this.state.dragging),
        className: n,
        onDrop: this.handleDrop,
        onDragEnter: this.handleDragEnter,
        onDragStart: this.handleDragStart,
        onDragEnd: this.handleDragEnd,
        onDragOver: this.handleDragOver
      }, t.Children.toArray(this.props.children).map(function (r) {
        return t.cloneElement(r, {
          handle: e.setHandle
        });
      })));
    }
  }], o(f.prototype, c), l && o(f, l), f;
}(e);
a(s, "displayName", "DraggableContainer");
export { s as DraggableContainer };